"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var classnames_1 = __importDefault(require("classnames"));
var colors_1 = require("../../constants/colors");
var utils_1 = require("../../utils");
var Span = styled_components_1.default.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n  border-radius: ", ";\n  color: ", ";\n  cursor: ", ";\n  display: inline-block;\n  line-height: 0;\n  height: ", ";\n  padding: ", ";\n  width: ", ";\n"], ["\n  background-color: ",
    ";\n  border-radius: ", ";\n  color: ", ";\n  cursor: ", ";\n  display: inline-block;\n  line-height: 0;\n  height: ", ";\n  padding: ", ";\n  width: ", ";\n"])), function (_a) {
    var circular = _a.circular, theme = _a.theme;
    return circular ? utils_1.parseThemePath(circular, theme, colors_1.colors.BLUE_300) : 'transparent';
}, function (_a) {
    var circular = _a.circular;
    return (circular ? '100%' : '0');
}, function (_a) {
    var theme = _a.theme, color = _a.color;
    return utils_1.parseThemePath(color, theme, colors_1.colors.GREY_650);
}, function (_a) {
    var cursor = _a.cursor;
    return cursor ? cursor : 'default';
}, function (_a) {
    var circular = _a.circular, size = _a.size;
    return circular ? "calc(" + size + " * 2)" : 'auto';
}, function (_a) {
    var circular = _a.circular, size = _a.size;
    return circular ? "calc(" + size + " / 2)" : 0;
}, function (_a) {
    var circular = _a.circular, size = _a.size;
    return circular ? "calc(" + size + " * 2)" : 'auto';
});
var CustomIcon = styled_components_1.default.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: inline-block;\n  height: ", ";\n  width: ", ";\n"], ["\n  display: inline-block;\n  height: ", ";\n  width: ", ";\n"])), function (_a) {
    var height = _a.height;
    return height;
}, function (_a) {
    var width = _a.width;
    return width;
});
var AXSIcon = function (props) {
    var _a;
    var classes = [
        'c-axs-icon',
        (_a = {}, _a["c-axs-icon--" + props.name] = props.name, _a),
        props.className,
    ];
    if (props.name) {
        try {
            var MaterialIcon = require("react-icons/lib/md/" + props.name);
            var onClick = props.onClick, rest = __rest(props, ["onClick"]);
            return (React.createElement(Span, __assign({ onClick: onClick }, rest, { className: classnames_1.default(classes) }),
                React.createElement(MaterialIcon, __assign({ style: { top: '3px', left: 0 }, color: props.color, width: props.size, height: props.size }, rest))));
        }
        catch (e) {
            if (e.code !== 'MODULE_NOT_FOUND') {
                throw e;
            }
            console.error("Invalid Material Icon name provided: " + props.name);
            return React.createElement("div", null);
        }
    }
    else {
        return (React.createElement(Span, __assign({}, props),
            React.createElement(CustomIcon, { style: { width: props.width, height: props.height } }, props.path)));
    }
};
AXSIcon.defaultProps = {
    color: 'axsui.brand.primary.default',
    size: '22px',
};
exports.default = AXSIcon;
var templateObject_1, templateObject_2;
//# sourceMappingURL=index.js.map